import { Component, OnInit } from '@angular/core';
import { faCheck } from '@fortawesome/free-solid-svg-icons';


@Component({
    selector: 'app-responsability',
    templateUrl: './responsability.component.html',
    styleUrls: ['./responsability.component.less'],
    standalone: false
})
export class ResponsabilityComponent implements OnInit {

  faCheck = faCheck;

  constructor() { }

  ngOnInit() {
  }

}
